/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import BrowserLocales from 'embercom/lib/browser-locales';

export default buildHelper(function (languageCode) {
  return BrowserLocales[languageCode];
});
